import React from "react";

function ApproveSupplier() {
  return <div>ApproveSupplier</div>;
}

export default ApproveSupplier;
